import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../context/AppContext";
import Chip from "../Chip";
import { ALL_TAB } from "../../util/menuTabs";

/** The category tabs: "All" first, then the menu's categories. */
const Index = () => {
  const { selectedTab, setSelectedTab, categoryList } = useAppContext();
  const { t } = useTranslation();
  const tabsRef = useRef(null);

  useEffect(() => {
    const el = tabsRef.current?.querySelector('[aria-pressed="true"]');
    el?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [selectedTab]);

  const tabs = [
    { key: ALL_TAB, name: t("All") },
    ...(categoryList || []).map((cat) => ({
      key: cat?.translations?.name,
      name: cat?.translations?.name,
    })),
  ];

  return (
    <div
      ref={tabsRef}
      className="flex gap-2.5 overflow-x-auto scrollbar-hide -mx-5 px-5 pt-1 pb-4 -mb-3"
      role="group"
      aria-label={t("Categories")}
    >
      {tabs.map((tab) => (
        <Chip
          key={tab.key}
          selected={selectedTab === tab.key}
          onClick={() => setSelectedTab(tab.key)}
          className="flex-none px-5"
        >
          {tab.name}
        </Chip>
      ))}
    </div>
  );
};
export default Index;
